import { AppError } from '@vk-hr-tek/core/error';

import { AuthInstance } from '@app/gen/users';

import { ThunkExtra as AppThunkExtra } from '../../app/store';

export type ThunkExtra = Omit<AppThunkExtra, 'rejectValue'> & {
  rejectValue: AppError;
};

export interface AuthState {
  authInstances: {
    status: 'idle' | 'loading' | 'complete' | 'failed';
    instances: AuthInstance[];
    error: AppError | null;
  };
  status: 'idle' | 'loading' | 'complete' | 'failed';
  notification: {
    title: string;
    description: string;
    traceId?: string | null;
  } | null;
  inviteCode: string | null;
  authCode: string | null;
  openIdToken: string | null;
  passCode: string | null;
  values: {
    phone: string | null;
    password: string | null;
    snils: string | null;
    code: string | null;
  };
  stage: 'snils' | 'init' | 'verification' | 'finish' | 'error';
}

export const initialState: AuthState = {
  authInstances: {
    status: 'idle',
    instances: [],
    error: null,
  },
  status: 'idle',
  notification: null,
  inviteCode: null,
  authCode: null,
  passCode: null,
  openIdToken: null,
  stage: 'init',
  values: {
    phone: null,
    password: null,
    snils: null,
    code: null,
  },
};

export const clearState = (state: AuthState) => {
  state.status = 'idle';
  state.notification = null;
  state.stage = 'init';
};

export const resetState = (state: AuthState) => {
  state.authInstances = initialState.authInstances;
  state.status = initialState.status;
  state.notification = initialState.notification;
  state.inviteCode = initialState.inviteCode;
  state.authCode = initialState.authCode;
  state.passCode = initialState.passCode;
  state.stage = initialState.stage;
  state.values = initialState.values;
};

export const startLoading = (state: AuthState) => {
  state.status = 'loading';
  state.notification = null;
};

export const completeLoading = (state: AuthState) => {
  state.status = 'complete';
  state.notification = null;
};

export const setError = (
  state: AuthState,
  {
    payload,
  }: {
    payload?: { title: string; description: string; traceId?: string | null };
  },
) => {
  state.status = 'failed';
  state.notification = {
    description:
      (payload && payload.description) ||
      'Что-то пошло не так. Попробуйте еще раз',
    title:
      (payload && payload.title) || 'Что-то пошло не так. Попробуйте еще раз',
    traceId: payload?.traceId || null,
  };
};
